import { useMemo } from 'react'
import type { ReactNode } from 'react'

interface FilterConfig {
  label: string
  component?: ReactNode
  visible?: boolean
}

interface UseAddFilterProps {
  allFilters: Record<string, FilterConfig>
  selectedFilters: string[]
  onAddFilter: (filter: string) => void
}

export const useAddFilter = ({ allFilters, selectedFilters, onAddFilter }: UseAddFilterProps) => {
  const availableFilters = useMemo(() => {
    return Object.entries(allFilters)
      .filter(([key, filter]) => !selectedFilters.includes(key) && (filter.visible ?? true))
      .map(([key, filter]) => ({
        label: filter.label,
        value: key,
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [allFilters, selectedFilters])

  const onSelectFilter = (filterValue: string) => {
    onAddFilter(filterValue)
  }

  return {
    availableFilters,
    onSelectFilter,
  }
}
